import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from 'src/app/data.service';

@Component({
  selector: 'app-szamlatomb',
  templateUrl: './szamlatomb.component.html',
  styleUrls: ['./szamlatomb.component.scss'],
})
export class SzamlatombComponent implements OnInit {
  sajatIntezmeny: any;
  tombok: any[] = [];
  uj: any = { nev: '', elotag: '', formatum: 0, def: false, storno: false, modosito: false, szamviteli: false, folytonos: false };
  config = {
    default_proforma_tomb_id: '',
    default_invoice_tomb_id: '',
    storno_tomb_id: '',
    modosito_tomb_id: '',
    szamviteli_tomb_id: '',
  };
  profil: any = {
    cegnev: '', adoszam: '', irsz: '', telepules: '',
    kozterulet_nev: '', kozterulet_jelleg: '', hazszam: '', bankszam: '',
  };
  loading = false;

  constructor(private http: HttpClient, private data: DataService) { }

  async ngOnInit() {
    this.sajatIntezmeny = await this.data.getFromStorage('sajatIntezmeny');
    this.betolt();
  }

  private intezmenyId(): string {
    return this.sajatIntezmeny?.intezmenyId;
  }

  betolt() {
    this.http.get<any>('/api/szamla/profil/' + this.intezmenyId()).subscribe({
      next: (p) => {
        if (p) this.profil = {
          cegnev: p.cegnev || '', adoszam: p.adoszam || '', irsz: p.irsz || '', telepules: p.telepules || '',
          kozterulet_nev: p.kozterulet_nev || '', kozterulet_jelleg: p.kozterulet_jelleg || '',
          hazszam: p.hazszam || '', bankszam: p.bankszam || '',
        };
      },
      error: () => {},
    });
    this.loading = true;
    this.http.get<any>('/api/szamla/tomb-config/' + this.intezmenyId()).subscribe({
      next: (r) => {
        this.tombok = (r?.szamlatombok || []).map((t) => ({
          ...t, def: !!t.def, storno: !!t.storno, modosito: !!t.modosito, szamviteli: !!t.szamviteli, folytonos: !!t.folytonos,
        }));
        this.config = {
          default_proforma_tomb_id: r?.default_proforma_tomb_id || '',
          default_invoice_tomb_id: r?.default_invoice_tomb_id || '',
          storno_tomb_id: r?.storno_tomb_id || '',
          modosito_tomb_id: r?.modosito_tomb_id || '',
          szamviteli_tomb_id: r?.szamviteli_tomb_id || '',
        };
        this.loading = false;
      },
      error: () => { this.loading = false; this.data.sendToast('Nem sikerült betölteni a számlatömböket.', 'error'); },
    });
  }

  tombLabel(t: any): string {
    return `${t.nev || ''} (${t.elotag || ''})`.trim();
  }

  hozzaad() {
    if (!this.uj.nev || !this.uj.elotag) {
      this.data.sendToast('A név és az előtag kötelező.', 'error');
      return;
    }
    this.http.post('/api/szamla/tomb', { ...this.uj, intezmeny: this.intezmenyId() }).subscribe({
      next: () => {
        this.data.sendToast('Számlatömb létrehozva.', 'success');
        this.uj = { nev: '', elotag: '', formatum: 0, def: false, storno: false, modosito: false, szamviteli: false, folytonos: false };
        this.betolt();
      },
      error: (e) => this.data.sendToast(e?.error?.error || 'A létrehozás sikertelen.', 'error'),
    });
  }

  ment(t: any) {
    this.http.put('/api/szamla/tomb/' + t.id, { ...t, intezmeny: this.intezmenyId() }).subscribe({
      next: () => { this.data.sendToast('Mentve.', 'success'); this.betolt(); },
      error: (e) => this.data.sendToast(e?.error?.error || 'A mentés sikertelen.', 'error'),
    });
  }

  torol(t: any) {
    if (!confirm(`Biztosan törlöd a(z) "${t.nev}" tömböt?`)) return;
    this.http.delete('/api/szamla/tomb/' + t.id).subscribe({
      next: () => { this.data.sendToast('Törölve.', 'success'); this.betolt(); },
      error: (e) => this.data.sendToast(e?.error?.error || 'A törlés sikertelen.', 'error'),
    });
  }

  configMent() {
    this.http.put('/api/szamla/tomb-config/' + this.intezmenyId(), this.config).subscribe({
      next: () => { this.data.sendToast('Tömb-szerepek mentve.', 'success'); this.betolt(); },
      error: (e) => this.data.sendToast(e?.error?.error || 'A mentés sikertelen.', 'error'),
    });
  }

  profilMent() {
    this.http.put('/api/szamla/profil/' + this.intezmenyId(), this.profil).subscribe({
      next: () => this.data.sendToast('Számlakibocsátó adatok mentve.', 'success'),
      error: (e) => this.data.sendToast(e?.error?.error || 'A mentés sikertelen.', 'error'),
    });
  }
}
